function checkDomainInput (input) {
    var domainPattern =
        /^(http(s)?:\/\/)?([\w-]+\.)*([\w-]+\.[a-zA-Z]{2,63})(\/[\w-./?%&=]*)?$/

    if (input.value === '') {
        input.style.border = '' // Возвращаем дефолтные стили границы
    } else if (domainPattern.test(input.value)) {
        input.style.border = '2px solid #A8E300' // Граница зеленого цвета для правильного ввода
    } else {
        input.style.border = '2px solid #FF8F70' // Граница красного цвета для неправильного ввода
    }
}

function checkInput (input) {
    if (input.value !== '') {
        input.style.opacity = '1'
    } else {
        input.style.opacity = '0.4'
    }
}
